import "../assets/css/App.css";
import * as React from "react";
import parrotLogo from "../assets/images/parrotsiconpaddedtransparent.png";
import { VoyageDetailBidButton } from "../components/VoyageDetailBidButton";
import { IoPersonOutline, IoPeopleOutline, IoCloseCircleOutline, IoCheckmarkCircleOutline } from "react-icons/io5";
import { useAcceptBidMutation, useDeleteBidMutation } from "../slices/VoyageSlice";
import { useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { parrotGreen, parrotTextDarkBlue } from "../styles/colors";
import { CustomToolTipBidMessage } from "./CustomToolTipBidMessage";
import { invokeHub } from "../signalr/signalRHub";

const baseUserImageUrl = ``;

export function VoyageDetailBidsLight({
  userId, voyageId, voyageData, ownVoyage, userBid, userBidAccepted,
  currentUserId, isSuccessVoyage, refetch, setOpacity,
}) {
  const [acceptBid] = useAcceptBidMutation();
  const [deleteBid] = useDeleteBidMutation();
  const username = localStorage.getItem("storedUserName");
  const [loadingBidId, setLoadingBidId] = React.useState(null);
  const [bidsData, setBidsData] = React.useState([...voyageData?.bids]);

  useEffect(() => { setBidsData([...voyageData?.bids]); }, [voyageData?.bids]);
  const makeRefetch = useCallback(() => { refetch(); }, [refetch]);

  const handleAcceptBid = async ({ bidId, bidUserId }) => {
    setLoadingBidId(bidId);
    const text = `Hi there! 👋 Welcome on board to "${voyageData.name}" 🎉`;
    try {
      await invokeHub("SendMessage", currentUserId, bidUserId, text);
      await acceptBid(bidId).unwrap();
      setBidsData((prevBids) => prevBids.map((bid) => bid.id === bidId ? { ...bid, accepted: true } : bid));
      makeRefetch();
    } catch (error) { console.error("Error accepting bid:", error); }
    finally { setLoadingBidId(null); }
  };

  const handleDeleteBid = async ({ bidId, bidUserId }) => {
    setLoadingBidId(bidId);
    const text = `Hi there! 👋 Your bid was deleted by ${username}`;
    try {
      await invokeHub("SendMessage", currentUserId, bidUserId, text);
      await deleteBid(bidId).unwrap();
      setBidsData((prevBids) => prevBids.filter((bid) => bid.id !== bidId));
      makeRefetch();
    } catch (error) { console.error("Error deleting bid:", error); }
    finally { setLoadingBidId(null); }
  };

  return (
    <div style={cardContainerStyle}>
      <div style={{ overflow: "auto", minHeight: "50vh", scrollbarWidth: "none", msOverflowStyle: "none" }}>
        <div className="BidsList">
          <BidsList bidsData={bidsData} ownVoyage={ownVoyage} handleAcceptBid={handleAcceptBid} handleDeleteBid={handleDeleteBid} loadingBidId={loadingBidId} />
        </div>
      </div>
      <VoyageDetailBidButton
        ownVoyage={ownVoyage} userBid={userBid} userProfileImage={voyageData?.user?.profileImageUrl}
        userName={voyageData?.user?.userName} userBidAccepted={userBidAccepted} setOpacity={setOpacity}
        userId={userId} voyageId={voyageId} refetch={refetch}
      />
    </div>
  );
}

function BidsList({ bidsData, ownVoyage, handleAcceptBid, handleDeleteBid, loadingBidId }) {
  if (bidsData.length === 0) {
    return (
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", paddingTop: "4rem", opacity: 0.3 }}>
        <img src={parrotLogo} alt="No bids" style={{ width: "12rem", height: "12rem", objectFit: "contain", marginTop: "1rem" }} />
      </div>
    );
  }
  return bidsData.map((bid, i) => (
    <RenderBid
      key={`bid-${i}`}
      username={bid.userName} userImage={baseUserImageUrl + bid.userProfileImage}
      message={bid.message} price={bid.offerPrice} accepted={bid.accepted}
      personCount={bid.personCount} ownVoyage={ownVoyage} handleAcceptBid={handleAcceptBid}
      bidId={bid.id} bidUserId={bid.userId} bidUserPublicId={bid.userPublicId}
      loadingBidId={loadingBidId} handleDeleteBid={handleDeleteBid}
    />
  ));
}

function RenderBid({ username, userImage, message, price, accepted, personCount, ownVoyage, handleAcceptBid, bidId, bidUserId, bidUserPublicId, loadingBidId, handleDeleteBid }) {
  const [hoveredUserImgID, setHoveredUserImgID] = React.useState("");
  const [isHoveredBid, setIsHoveredBid] = React.useState(false);
  const navigate = useNavigate();

  return (
    <div style={{ ...dataRowItem, height: ownVoyage ? "4.5rem" : "4rem", position: "relative" }}>
      <div style={leftItem}>
        <div style={imgWrapper}>
          <img
            src={userImage}
            style={{ ...userImageStyle, ...(hoveredUserImgID === bidUserId ? { transform: "scale(1.2)" } : {}) }}
            onMouseEnter={() => setHoveredUserImgID(bidUserId)}
            onMouseLeave={() => setHoveredUserImgID("")}
            alt=""
            onClick={() => navigate(`/profile-public/${bidUserPublicId}/${username}`)}
          />
        </div>
      </div>
      <div style={{ ...middleTopItem, gridRow: ownVoyage ? "1" : "1 / span 2" }}>
        <span style={userNameStyle}>{username}</span>
        <span style={personCountStyle}>
          {personCount === 1 ? <IoPersonOutline size="1rem" style={{ marginRight: "0.15rem" }} /> : <IoPeopleOutline size="1rem" style={{ marginRight: "0.15rem" }} />}
          {personCount}
        </span>
        <span style={bidAmount}>€{price}</span>
      </div>
      <div style={middleBottomItem} onMouseEnter={() => setIsHoveredBid(true)} onMouseLeave={() => setIsHoveredBid(false)}>
        {ownVoyage ? <span style={bidMessage}>{message}</span> : " "}
        {ownVoyage && message && <CustomToolTipBidMessage isHovered={isHoveredBid} message={message} />}
      </div>
      <div style={rightItem}>
        <span
          onClick={() => ownVoyage && !accepted && !loadingBidId && handleAcceptBid({ bidId, bidUserId })}
          style={{
            ...(accepted ? acceptedBidStyle : acceptBidStyle),
            cursor: ownVoyage && !accepted ? "pointer" : "default",
            paddingLeft: "0.4rem",
            paddingRight: "0.4rem"
          }}
        >
          {loadingBidId === bidId && !accepted ? <AcceptBidSpinner /> : accepted ? "Accepted" : ownVoyage ? "Accept" : "Pending"}
        </span>
        <span onClick={() => handleDeleteBid({ bidId, bidUserId })} style={{ marginLeft: "0.5rem", marginRight: "0.5rem", cursor: ownVoyage && accepted ? "" : "pointer" }}>
          {ownVoyage && (accepted ? <IoCheckmarkCircleOutline color={parrotGreen} size={20} /> : <IoCloseCircleOutline color="orangered" size={20} />)}
        </span>
      </div>
    </div>
  );
}

const AcceptBidSpinner = () => (
  <div style={{ backgroundColor: "rgba(0,119,234,0.1)", borderRadius: "1.5rem", position: "relative", margin: "auto", height: "1.2rem", display: "flex", alignItems: "center" }}>
    <div className="spinner" style={{ height: "1rem", width: "1rem", border: "3px solid #ccc", borderTop: "3px solid #1e90ff" }} />
  </div>
);

const userImageStyle = { height: "3rem", width: "3rem", borderRadius: "3rem", transition: "transform 0.3s ease-in-out", cursor: "pointer" };
const imgWrapper = { transition: "transform 0.3s ease-in-out", cursor: "pointer" };

const cardContainerStyle = {
  display: "flex", flexDirection: "column", borderRadius: "1rem", width: "100%",
  backgroundColor: "#ffffff", margin: "0rem", color: parrotTextDarkBlue,
  padding: "1rem", fontSize: "1.15rem", height: "52vh",
  scrollbarWidth: "none", msOverflowStyle: "none",
  boxShadow: "0 4px 6px rgba(0,0,0,0.15)",
};

const dataRowItem = {
  display: "grid", gridTemplateRows: "1fr 1fr", gridTemplateColumns: "1.5fr 6fr 3fr",
  gap: "0.2rem", marginTop: "0.3rem", borderRadius: "1rem", padding: "0.5rem",
  width: "100%", backgroundColor: "rgba(0,119,234,0.05)",
  boxShadow: "0 2px 4px rgba(0,0,0,0.08)",
};

const leftItem = { gridRow: "1 / span 2", gridColumn: "1", display: "flex", justifyContent: "center", alignItems: "center" };

const middleTopItem = {
  gridColumn: "2", justifyContent: "center", alignItems: "center", display: "grid",
  gridTemplateColumns: "minmax(0,1fr) 5rem 5rem",
};

const middleBottomItem = { gridRow: "2", gridColumn: "2", display: "flex", justifyContent: "center", width: "100%" };

const rightItem = { gridRow: "1 / span 2", gridColumn: "3", justifyContent: "center", alignItems: "center", display: "grid", gridTemplateColumns: "2fr 1fr" };

const userNameStyle = { width: "100%", whiteSpace: "nowrap", fontWeight: "500", paddingLeft: "0.2rem", textAlign: "left", color: parrotTextDarkBlue };

const personCountStyle = { width: "100%", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", display: "inline-flex", alignItems: "center", justifyContent: "center", fontWeight: "700", color: parrotTextDarkBlue };

const bidMessage = {
  whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis",
  backgroundColor: "rgba(0,119,234,0.06)", borderRadius: "1rem",
  padding: "0.2rem 0.5rem", width: "15rem", fontSize: "0.8rem",
  color: parrotTextDarkBlue, fontWeight: "500", cursor: "pointer",
};

const bidAmount = { alignSelf: "center", color: "#2ac898", fontWeight: "700", width: "100%" };

const acceptBidStyle = {
  fontWeight: "bold", color: "#0077EA", fontSize: "0.9rem",
  backgroundColor: "rgba(0,119,234,0.1)", borderRadius: "1rem",
  marginLeft: "0.5rem", marginRight: "0.5rem", paddingLeft: "0.3rem", paddingRight: "0.3rem",
};

const acceptedBidStyle = {
  fontWeight: "bold", color: "#2ac898", fontSize: "0.9rem",
  backgroundColor: "rgba(42,200,152,0.1)", borderRadius: "1rem",
  marginLeft: "0.5rem", marginRight: "0.5rem",
};
